module.exports = __webpack_public_path__ + "static/media/wStory.267e3741.svg";